import ChipInGlimpse from 'components/glimpses/chip_in_glimpse'
import ChipInAmount from 'components/glimpses/chip_in_glimpse/chip_in_amount'
import ChipInComplete from 'components/glimpses/chip_in_glimpse/chip_in_complete'
import Pledge from 'components/glimpses/chip_in_glimpse/pledge'
import NoChipIn from 'components/glimpses/chip_in_glimpse/no_chip_in'

import {
  trackEnter,
  trackChange,
  addGlimpselessRouteToHistory,
} from 'lib/glimpse'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'
import {
  glimpselessRoute,
  assertInitialStep,
  assignActionToRouterParams,
} from 'lib/route_utils'
import { isCampaignOwner } from 'lib/is_owner'

export default (store, history) => ({
  path: 'chip_in',
  component: { glimpse: ChipInGlimpse },
  onEnter(nextState, replace) {
    if (isCampaignOwner(store, nextState.params.campaignId)) {
      trackEnter('chip_in', nextState, replace)
      assertInitialStep('chip_in', 'pledge', nextState, replace)
    } else {
      replace(glimpselessRoute('chip_in'))
    }
  },
  onChange(prevState, nextState, replace) {
    assignActionToRouterParams(nextState)
    trackChange('chip_in', prevState, nextState, replace)
  },
  childRoutes: [
    {
      path: 'pledge',
      component: Pledge,
      onEnter(nextState, replace) {
        sendEnsightenEvent('MoneyPoolPledgeStart')
        addGlimpselessRouteToHistory('chip_in', nextState, replace, history)
      },
    },
    {
      path: 'na',
      component: NoChipIn,
      onEnter(nextState, replace) {
        addGlimpselessRouteToHistory('chip_in', nextState, replace, history)
      },
    },
    {
      path: 'amount',
      component: ChipInAmount,
      onEnter(nextState, replace) {
        addGlimpselessRouteToHistory('chip_in', nextState, replace, history)
      },
    },
    { path: 'complete', component: ChipInComplete },
  ],
})
